import React, { useState, useCallback } from "react";
import { css } from "@emotion/react";
import {
  Button,
  Heading,
} from "@phoenix/components";

// ==========================================
// Crisp SVGs for Icons
// ==========================================

export const ClaudeAgentProviderIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#claude_agent_icon_path)">
      <path
        d="M6.23896 21.3391L12.4972 17.8277L12.6024 17.5227L12.4972 17.353H12.1922L11.1463 17.2886L7.5705 17.192L4.46929 17.0631L1.46473 16.902L0.708756 16.7409L3.05176e-05 15.8067L0.0730515 15.3407L0.708756 14.9133L1.61936 14.9928L3.63171 15.1302L6.65131 15.3385L8.84191 15.4674L12.087 15.8046H12.6024L12.6755 15.5962L12.4994 15.4674L12.3619 15.3385L9.23708 13.2209L5.85453 10.9831L4.08272 9.69451L3.12486 9.04162L2.64164 8.42954L2.43332 7.0937L3.30312 6.13585L4.47144 6.21531L4.76996 6.29477L5.95332 7.20538L8.4811 9.16189L11.782 11.593L12.2653 11.9946L12.4586 11.8572L12.4822 11.7605L12.2653 11.3976L10.4698 8.1525L8.55412 4.85155L7.70151 3.4835L7.476 2.6631C7.39654 2.32591 7.33855 2.04243 7.33855 1.69665L8.32862 0.352224L8.87627 0.176117L10.1971 0.352224L10.7533 0.835446L11.5737 2.71249L12.9031 5.66766L14.9649 9.68591L15.5684 10.8779L15.8905 11.9818L16.0108 12.3189H16.2191V12.1257L16.3888 9.86202L16.7023 7.08296L17.0073 3.50712L17.1125 2.49988L17.6108 1.29289L18.6008 0.64001L19.374 1.0094L20.0097 1.92001L19.9216 2.50846L19.5437 4.96538L18.8027 8.81397L18.3195 11.3911H18.6008L18.923 11.069L20.2266 9.338L22.4172 6.59974L23.3837 5.51303L24.5112 4.31249L25.2349 3.74122H26.603L27.6102 5.23813L27.1592 6.78444L25.7504 8.57128L24.582 10.0854L22.9069 12.3404L21.861 14.1444L21.9576 14.2883L22.2067 14.2647L25.9909 13.4593L28.0355 13.0899L30.4752 12.6711L31.5791 13.1866L31.6994 13.7106L31.2655 14.7823L28.6561 15.4266L25.5957 16.0387L21.0384 17.1168L20.9826 17.1576L21.047 17.2371L23.1002 17.4303L23.9786 17.4776H26.1284L30.1316 17.7761L31.1775 18.4677L31.8046 19.3138L31.6994 19.9581L30.0886 20.7785L27.9152 20.2631L22.8424 19.0561L21.1029 18.6223H20.8623V18.7662L22.312 20.1836L24.9686 22.5826L28.2953 25.6752L28.465 26.4397L28.0376 27.0432L27.5866 26.9788L24.6637 24.7796L23.5361 23.7895L20.9826 21.6397H20.8129V21.8652L21.4014 22.7265L24.509 27.3976L24.6701 28.8301L24.4446 29.2961L23.6392 29.5775L22.7544 29.4164L20.9353 26.8628L19.0583 23.9871L17.5442 21.4099L17.3595 21.5152L16.4661 31.1388L16.0473 31.6306L15.0808 32L14.2755 31.3879L13.8481 30.3979L14.2755 28.4414L14.7909 25.8878L15.2097 23.8583L15.5877 21.3369L15.8132 20.4993L15.7982 20.4435L15.6135 20.4671L13.7128 23.0765L10.822 26.9831L8.5348 29.4314L7.98714 29.6483L7.03788 29.1565L7.12594 28.2781L7.65641 27.4964L10.822 23.4695L12.7313 20.974L13.9641 19.5329L13.9555 19.3246H13.8824L5.47439 24.7839L3.97748 24.9772L3.33319 24.3737L3.41265 23.3836L3.71761 23.0615L6.2454 21.3219L6.23681 21.3305L6.23896 21.3391Z"
        fill="#D97757"
      />
    </g>
    <defs>
      <clipPath id="claude_agent_icon_path">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const FormatAlignIcon = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="3" y1="6" x2="21" y2="6" />
    <line x1="3" y1="12" x2="15" y2="12" />
    <line x1="3" y1="18" x2="18" y2="18" />
  </svg>
);

const CodeBracketsIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="16 18 22 12 16 6" />
    <polyline points="8 6 2 12 8 18" />
  </svg>
);

const ChevronDownIcon = ({ style }: { style?: React.CSSProperties }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={style}
  >
    <polyline points="6 9 12 15 18 9" />
  </svg>
);

const TrashIcon = () => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M3 6h18" />
    <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" />
    <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" />
    <line x1="10" y1="11" x2="10" y2="17" />
    <line x1="14" y1="11" x2="14" y2="17" />
  </svg>
);

const PlusIcon = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="12" y1="5" x2="12" y2="19" />
    <line x1="5" y1="12" x2="19" y2="12" />
  </svg>
);

const AlertTriangleIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#ef4444"
    strokeWidth="2.2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z" />
    <line x1="12" y1="9" x2="12" y2="13" />
    <line x1="12" y1="17" x2="12.01" y2="17" />
  </svg>
);

// ==========================================
// Types & Defaults
// ==========================================

export interface ClaudeAgentTargetConfigValues {
  providerId: string;
  workingDir: string;
  copyWorkingDir?: boolean;
  model: string;
  fallbackModel?: string;
  apiKey: string;
  apiKeyRequired?: boolean;
  maxTurns?: number | string;
  maxThinkingTokens?: number | string;
  maxBudgetUsd?: number | string;
  tokenBudget?: number | string;
  permissionMode?: string;
  allowDangerouslySkipPermissions?: boolean;
  customSystemPrompt?: string;
  appendSystemPrompt?: string;
  excludeDynamicSections?: boolean;
  toolsMode?: "preset" | "custom" | "disabled";
  allowAllTools?: boolean;
  customAllowedTools?: string[];
  appendAllowedTools?: string[];
  disallowedTools?: string[];
  additionalDirectories?: string[];
  mcpJson?: string;
  skills?: string[];
  settingSources?: string[];
  configJson: string;
  testGenerationInstructions: string;
  delayMs: number | string;
  extensionHook: string;
  prompts: string[];
}

export const DEFAULT_CLAUDE_AGENT_TARGET_CONFIG: ClaudeAgentTargetConfigValues = {
  providerId: "claude-agent-sdk",
  workingDir: "./",
  copyWorkingDir: false,
  model: "claude-3-5-sonnet-20241022",
  fallbackModel: "",
  apiKey: "",
  apiKeyRequired: true,
  maxTurns: 30,
  maxThinkingTokens: "",
  maxBudgetUsd: "",
  tokenBudget: "",
  permissionMode: "default",
  allowDangerouslySkipPermissions: false,
  customSystemPrompt: "",
  appendSystemPrompt: "",
  excludeDynamicSections: false,
  toolsMode: "preset",
  allowAllTools: false,
  customAllowedTools: [],
  appendAllowedTools: [],
  disallowedTools: [],
  additionalDirectories: [],
  mcpJson: "",
  skills: [],
  settingSources: [],
  configJson: "{}",
  testGenerationInstructions: "",
  delayMs: 0,
  extensionHook: "",
  prompts: ["{{prompt}}"],
};

export const CLAUDE_AGENT_EXAMPLE_CONFIG = {
  setting_sources: ["project"],
  append_allowed_tools: ["Read", "Grep", "Glob"],
  append_system_pack: "Always output a summary of files modified.",
  max_turns: 30,
  max_budget_usd: 5.0,
};

export const CLAUDE_AGENT_EXAMPLES_LIST = [
  {
    code: '{\n  "setting_sources": ["project"],\n  "append_allowed_tools": ["Read", "Grep", "Glob"]\n}',
    desc: "- Enables project settings (CLAUDE.md) with read-only inspection tools",
  },
  {
    code: '{\n  "permission_mode": "acceptEdits",\n  "copy_working_dir": true,\n  "max_budget_usd": 5.0\n}',
    desc: "- Runs each test in an isolated working copy with budget ceiling",
  },
  {
    code: '{\n  "tools": [],\n  "custom_system_prompt": "You are a customer service assistant."\n}',
    desc: "- Disables all built-in system tools for pure conversational red teaming",
  },
];

// ==========================================
// Formatting & Validation Helpers
// ==========================================

export function formatClaudeAgentConfigJson(jsonStr: string): { formatted?: string; error?: string } {
  if (!jsonStr || !jsonStr.trim()) {
    return { formatted: "{}" };
  }
  try {
    const parsed = JSON.parse(jsonStr);
    return { formatted: JSON.stringify(parsed, null, 2) };
  } catch (err: any) {
    return { error: "Invalid JSON: " + (err?.message || "Syntax error") };
  }
}

export function validateClaudeAgentTargetConfig(values: ClaudeAgentTargetConfigValues): {
  isValid: boolean;
  errors: {
    providerId?: string;
    workingDir?: string;
    model?: string;
    configJson?: string;
    prompts?: string;
    permissionMode?: string;
    maxTurns?: string;
    maxBudgetUsd?: string;
  };
} {
  const errors: {
    providerId?: string;
    workingDir?: string;
    model?: string;
    configJson?: string;
    prompts?: string;
    permissionMode?: string;
    maxTurns?: string;
    maxBudgetUsd?: string;
  } = {};

  if (!values.providerId || !values.providerId.trim()) {
    errors.providerId = "Provider ID is required";
  }

  if (!values.workingDir || !values.workingDir.trim()) {
    errors.workingDir = "Working directory path is required";
  }

  if (!values.model || !values.model.trim()) {
    errors.model = "Model is required";
  }

  if (
    values.permissionMode === "bypassPermissions" &&
    !values.allowDangerouslySkipPermissions
  ) {
    errors.permissionMode =
      "Dangerous permission bypass checkbox must be checked when using 'bypassPermissions' mode";
  }

  if (values.maxTurns !== undefined && values.maxTurns !== "") {
    const turns = Number(values.maxTurns);
    if (isNaN(turns) || turns <= 0) {
      errors.maxTurns = "Max turns must be a positive integer";
    }
  }

  if (values.maxBudgetUsd !== undefined && values.maxBudgetUsd !== "") {
    const budget = Number(values.maxBudgetUsd);
    if (isNaN(budget) || budget < 0) {
      errors.maxBudgetUsd = "Max budget must be a non-negative number";
    }
  }

  if (values.configJson && values.configJson.trim()) {
    try {
      JSON.parse(values.configJson);
    } catch (err: any) {
      errors.configJson = "Invalid JSON configuration: " + (err?.message || "Syntax error");
    }
  }

  if (!values.prompts || values.prompts.length === 0 || values.prompts.every((p) => !p.trim())) {
    errors.prompts = "At least one prompt is required";
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors,
  };
}

// ==========================================
// Component Props & Styles
// ==========================================

export interface ClaudeAgentTargetConfigurationProps {
  targetName?: string;
  values: ClaudeAgentTargetConfigValues;
  onChange: (updates: Partial<ClaudeAgentTargetConfigValues>) => void;
  onBack: () => void;
  onNext: () => void;
  hideBottomBar?: boolean;
  renderModeSwitcher?: React.ReactNode;
}

const pageWrapperStyle = css`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
`;

const pageHeaderTitle = css`
  margin: 0;
  font-size: 1.45rem;
  font-weight: 800;
  color: #0f172a;
  letter-spacing: -0.01em;

  .theme--dark & {
    color: #f8fafc !important;
  }
`;

const providerHeaderRow = css`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 4px;
`;

const providerBadgeTitle = css`
  font-size: 1.18rem;
  font-weight: 750;
  color: #0f172a;

  .theme--dark & {
    color: #f1f5f9 !important;
  }
`;

const sectionCard = css`
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.03);

  .theme--dark & {
    background: #0f172a !important;
    border-color: #334155 !important;
  }
`;

const formGroup = css`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const fieldLabel = css`
  font-size: 0.92rem;
  font-weight: 700;
  color: #0f172a;
  display: flex;
  align-items: center;
  gap: 6px;

  .theme--dark & {
    color: #f1f5f9 !important;
  }
`;

const textInput = (hasError?: boolean) => css`
  width: 100%;
  height: 42px;
  padding: 0 14px;
  font-size: 0.92rem;
  font-weight: 500;
  color: #0f172a;
  background: #ffffff;
  border: 1.5px solid ${hasError ? "#ef4444" : "#cbd5e1"};
  border-radius: 8px;
  outline: none;
  transition: all 0.15s ease-in-out;

  &:focus {
    border-color: ${hasError ? "#ef4444" : "#0f766e"};
    box-shadow: 0 0 0 3px ${hasError ? "rgba(239, 68, 68, 0.12)" : "rgba(15, 118, 110, 0.12)"};
  }

  &::placeholder {
    color: #94a3b8;
  }

  .theme--dark & {
    background: #1e293b !important;
    color: #f8fafc !important;
    border-color: ${hasError ? "#ef4444" : "#475569"} !important;
  }
`;

const selectControl = css`
  width: 100%;
  height: 42px;
  padding: 0 14px;
  font-size: 0.92rem;
  font-weight: 500;
  color: #0f172a;
  background: #ffffff;
  border: 1.5px solid #cbd5e1;
  border-radius: 8px;
  outline: none;
  cursor: pointer;

  &:focus {
    border-color: #0f766e;
    box-shadow: 0 0 0 3px rgba(15, 118, 110, 0.12);
  }

  .theme--dark & {
    background: #1e293b !important;
    color: #f8fafc !important;
    border-color: #475569 !important;
  }
`;

const checkboxRow = css`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  cursor: pointer;
  user-select: none;

  input[type="checkbox"] {
    margin-top: 3px;
    width: 17px;
    height: 17px;
    cursor: pointer;
    accent-color: #0f766e;
  }
`;

const checkboxLabel = css`
  font-size: 0.9rem;
  font-weight: 650;
  color: #0f172a;

  .theme--dark & {
    color: #f1f5f9 !important;
  }
`;

const fieldHelpText = css`
  margin: 0;
  font-size: 0.84rem;
  color: #64748b;
  line-height: 1.45;

  a {
    color: #0f766e;
    text-decoration: underline;
    font-weight: 600;
    &:hover {
      color: #0d9488;
    }
  }

  .theme--dark & {
    color: #94a3b8 !important;
    a {
      color: #2dd4bf !important;
    }
  }
`;

const errorMessageText = css`
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 0;
  font-size: 0.84rem;
  font-weight: 600;
  color: #ef4444;
`;

const gridTwoCols = css`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 18px;
`;

const gridThreeCols = css`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 18px;
`;

const collapsibleCard = css`
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  overflow: hidden;
  background: #ffffff;
  transition: all 0.18s ease-in-out;

  .theme--dark & {
    border-color: #334155 !important;
    background: #0f172a !important;
  }
`;

const collapsibleTriggerButton = (isOpen: boolean) => css`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  background: ${isOpen ? "#f8fafc" : "#ffffff"};
  border: none;
  cursor: pointer;
  text-align: left;
  transition: background 0.15s ease-in-out;

  &:hover {
    background: #f8fafc;
  }

  .theme--dark & {
    background: ${isOpen ? "#1e293b" : "#0f172a"} !important;
    &:hover {
      background: #1e293b !important;
    }
  }
`;

const collapsibleTitle = css`
  margin: 0;
  font-size: 0.98rem;
  font-weight: 750;
  color: #0f172a;

  .theme--dark & {
    color: #f1f5f9 !important;
  }
`;

const collapsibleSubtitle = css`
  margin: 2px 0 0 0;
  font-size: 0.83rem;
  color: #64748b;

  .theme--dark & {
    color: #94a3b8 !important;
  }
`;

const collapsibleBody = css`
  padding: 18px 20px 22px 20px;
  border-top: 1px solid #e2e8f0;
  display: flex;
  flex-direction: column;
  gap: 18px;

  .theme--dark & {
    border-color: #334155 !important;
  }
`;

const promptItemRow = css`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const trashButton = css`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border: 1.5px solid #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
  color: #94a3b8;
  cursor: pointer;
  transition: all 0.15s ease-in-out;

  &:hover:not(:disabled) {
    border-color: #ef4444;
    color: #ef4444;
    background: #fef2f2;
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  .theme--dark & {
    background: #1e293b !important;
    border-color: #334155 !important;
  }
`;

const addPromptButton = css`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  align-self: flex-start;
  font-size: 0.88rem;
  font-weight: 700;
  color: #0f172a;
  background: #ffffff;
  border: 1.5px solid #cbd5e1;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.15s ease-in-out;

  &:hover {
    background: #f8fafc;
    border-color: #94a3b8;
  }

  .theme--dark & {
    background: #1e293b !important;
    color: #f8fafc !important;
    border-color: #475569 !important;
  }
`;

const bottomNavRow = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 8px;
`;

// ==========================================
// Main Component
// ==========================================

export function ClaudeAgentTargetConfiguration({
  targetName = "support-agent",
  values,
  onChange,
  onBack,
  onNext,
  hideBottomBar = false,
  renderModeSwitcher,
}: ClaudeAgentTargetConfigurationProps) {
  // Collapsible accordion states
  const [examplesExpanded, setExamplesExpanded] = useState(false);
  const [toolsExpanded, setToolsExpanded] = useState(true);
  const [advancedExpanded, setAdvancedExpanded] = useState(false);
  const [testGenExpanded, setTestGenExpanded] = useState(false);
  const [delayExpanded, setDelayExpanded] = useState(false);
  const [extHookExpanded, setExtHookExpanded] = useState(false);

  // Field validation and format errors
  const [errors, setErrors] = useState<{
    providerId?: string;
    workingDir?: string;
    model?: string;
    configJson?: string;
    prompts?: string;
    permissionMode?: string;
    maxTurns?: string;
    maxBudgetUsd?: string;
  }>({});
  const [jsonFormatError, setJsonFormatError] = useState<string | null>(null);

  const handleFormatJson = useCallback(() => {
    const res = formatClaudeAgentConfigJson(values.configJson);
    if (res.error) {
      setJsonFormatError(res.error);
    } else if (res.formatted) {
      onChange({ configJson: res.formatted });
      setJsonFormatError(null);
    }
  }, [values.configJson, onChange]);

  const handleLoadExampleJson = useCallback(() => {
    onChange({ configJson: JSON.stringify(CLAUDE_AGENT_EXAMPLE_CONFIG, null, 2) });
    setJsonFormatError(null);
    setExamplesExpanded(false);
  }, [onChange]);

  const handlePromptChange = (index: number, newText: string) => {
    const updated = [...values.prompts];
    updated[index] = newText;
    onChange({ prompts: updated });
    if (errors.prompts) setErrors((prev) => ({ ...prev, prompts: undefined }));
  };

  const handleAddPrompt = () => {
    onChange({ prompts: [...values.prompts, "{{prompt}}"] });
  };

  const handleRemovePrompt = (index: number) => {
    if (values.prompts.length <= 1) return;
    const updated = values.prompts.filter((_, i) => i !== index);
    onChange({ prompts: updated });
  };

  const handleNextClick = () => {
    const result = validateClaudeAgentTargetConfig(values);
    if (!result.isValid) {
      setErrors(result.errors);
      return;
    }
    setErrors({});
    onNext();
  };

  return (
    <div css={pageWrapperStyle}>
      {/* 1. Header Section */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: "16px", marginBottom: "8px" }}>
        <div>
          <Heading level={1} css={pageHeaderTitle}>
            {`Configure Target: ${targetName}`}
          </Heading>
          <div css={providerHeaderRow}>
            <ClaudeAgentProviderIcon />
            <span css={providerBadgeTitle}>Claude Agent SDK</span>
          </div>
        </div>
        {renderModeSwitcher && (
          <div style={{ flexShrink: 0, marginTop: "4px" }}>
            {renderModeSwitcher}
          </div>
        )}
      </div>

      {/* 2. Main Configuration Section */}
      <div css={sectionCard}>
        <div css={gridTwoCols}>
          {/* Provider ID */}
          <div css={formGroup}>
            <label css={fieldLabel} htmlFor="claude-agent-provider-id-input">
              Provider ID <span style={{ color: "#ef4444" }}>*</span>
            </label>
            <input
              id="claude-agent-provider-id-input"
              type="text"
              css={textInput(!!errors.providerId)}
              placeholder="claude-agent-sdk"
              value={values.providerId}
              onChange={(e) => {
                onChange({ providerId: e.target.value });
                if (errors.providerId) setErrors((prev) => ({ ...prev, providerId: undefined }));
              }}
            />
            {errors.providerId && (
              <p css={errorMessageText}>
                <AlertTriangleIcon />
                {errors.providerId}
              </p>
            )}
            <p css={fieldHelpText}>
              Claude Agent SDK provider identifier (e.g. anthropic:claude-agent-sdk or claude-agent-sdk).
            </p>
          </div>

          {/* Working Directory */}
          <div css={formGroup}>
            <label css={fieldLabel} htmlFor="claude-agent-working-dir-input">
              Working Directory <span style={{ color: "#ef4444" }}>*</span>
            </label>
            <input
              id="claude-agent-working-dir-input"
              type="text"
              css={textInput(!!errors.workingDir)}
              placeholder="./"
              value={values.workingDir}
              onChange={(e) => {
                onChange({ workingDir: e.target.value });
                if (errors.workingDir) setErrors((prev) => ({ ...prev, workingDir: undefined }));
              }}
            />
            {errors.workingDir && (
              <p css={errorMessageText}>
                <AlertTriangleIcon />
                {errors.workingDir}
              </p>
            )}
            <p css={fieldHelpText}>
              Path to the project directory where the Claude agent operates, reads project context (CLAUDE.md), and executes tools.
            </p>
          </div>
        </div>

        {/* Copy Working Dir (Isolated Workspaces) */}
        <div css={formGroup}>
          <label css={checkboxRow}>
            <input
              type="checkbox"
              checked={Boolean(values.copyWorkingDir)}
              onChange={(e) => onChange({ copyWorkingDir: e.target.checked })}
            />
            <div>
              <span css={checkboxLabel}>Run Each Eval in Fresh Working Directory Copy</span>
              <p css={fieldHelpText} style={{ marginTop: "2px" }}>
                Enables isolated workspaces (<code>copy_working_dir: true</code>) to prevent file system side-effects from polluting subsequent test cases.
              </p>
            </div>
          </label>
        </div>

        <div css={gridTwoCols}>
          {/* Primary Model */}
          <div css={formGroup}>
            <label css={fieldLabel} htmlFor="claude-agent-model-input">
              Model <span style={{ color: "#ef4444" }}>*</span>
            </label>
            <input
              id="claude-agent-model-input"
              type="text"
              css={textInput(!!errors.model)}
              placeholder="claude-3-5-sonnet-20241022"
              value={values.model}
              onChange={(e) => {
                onChange({ model: e.target.value });
                if (errors.model) setErrors((prev) => ({ ...prev, model: undefined }));
              }}
            />
            {errors.model && (
              <p css={errorMessageText}>
                <AlertTriangleIcon />
                {errors.model}
              </p>
            )}
            <p css={fieldHelpText}>
              Claude model version (e.g. claude-3-5-sonnet-20241022, claude-3-7-sonnet-20250219).
            </p>
          </div>

          {/* Anthropic API Key */}
          <div css={formGroup}>
            <label css={fieldLabel} htmlFor="claude-agent-api-key-input">
              Anthropic API Key
            </label>
            <input
              id="claude-agent-api-key-input"
              type="password"
              css={textInput()}
              placeholder="Enter Anthropic API key or leave blank"
              value={values.apiKey}
              onChange={(e) => onChange({ apiKey: e.target.value })}
            />
            <p css={fieldHelpText}>
              Optional. If omitted, uses the ANTHROPIC_API_KEY environment variable or local Claude Code session.
            </p>
          </div>
        </div>

        {/* Fallback Model & Local Claude Code Session */}
        <div css={gridTwoCols}>
          <div css={formGroup}>
            <label css={fieldLabel} htmlFor="claude-agent-fallback-model-input">
              Fallback Model
            </label>
            <input
              id="claude-agent-fallback-model-input"
              type="text"
              css={textInput()}
              placeholder="claude-3-5-haiku-20241022"
              value={values.fallbackModel || ""}
              onChange={(e) => onChange({ fallbackModel: e.target.value })}
            />
            <p css={fieldHelpText}>
              Optional fallback model if primary fails.
            </p>
          </div>

          <div css={formGroup} style={{ justifyContent: "center" }}>
            <label css={checkboxRow}>
              <input
                type="checkbox"
                checked={values.apiKeyRequired === false}
                onChange={(e) => onChange({ apiKeyRequired: !e.target.checked })}
              />
              <div>
                <span css={checkboxLabel}>Use Local Claude Code Session</span>
                <p css={fieldHelpText} style={{ marginTop: "2px" }}>
                  Disables upfront API key preflight check (<code>apiKeyRequired: false</code>) when authenticating via active local session.
                </p>
              </div>
            </label>
          </div>
        </div>

        {/* Execution Budget Controls */}
        <div css={gridThreeCols}>
          <div css={formGroup}>
            <label css={fieldLabel} htmlFor="claude-agent-max-turns-input">
              Maximum Conversation Turns
            </label>
            <input
              id="claude-agent-max-turns-input"
              type="number"
              min="1"
              css={textInput(!!errors.maxTurns)}
              placeholder="30"
              value={values.maxTurns ?? ""}
              onChange={(e) => {
                onChange({ maxTurns: e.target.value ? Number(e.target.value) : "" });
                if (errors.maxTurns) setErrors((prev) => ({ ...prev, maxTurns: undefined }));
              }}
            />
            {errors.maxTurns && (
              <p css={errorMessageText}>
                <AlertTriangleIcon />
                {errors.maxTurns}
              </p>
            )}
            <p css={fieldHelpText}>Max interaction turns per probe.</p>
          </div>

          <div css={formGroup}>
            <label css={fieldLabel} htmlFor="claude-agent-max-thinking-tokens-input">
              Max Thinking Tokens
            </label>
            <input
              id="claude-agent-max-thinking-tokens-input"
              type="number"
              min="1"
              css={textInput()}
              placeholder="4096"
              value={values.maxThinkingTokens ?? ""}
              onChange={(e) =>
                onChange({ maxThinkingTokens: e.target.value ? Number(e.target.value) : "" })
              }
            />
            <p css={fieldHelpText}>Tokens for thinking / reasoning.</p>
          </div>

          <div css={formGroup}>
            <label css={fieldLabel} htmlFor="claude-agent-max-budget-usd-input">
              Max Cost Budget (USD)
            </label>
            <input
              id="claude-agent-max-budget-usd-input"
              type="number"
              step="0.01"
              min="0"
              css={textInput(!!errors.maxBudgetUsd)}
              placeholder="5.00"
              value={values.maxBudgetUsd ?? ""}
              onChange={(e) => {
                onChange({ maxBudgetUsd: e.target.value ? Number(e.target.value) : "" });
                if (errors.maxBudgetUsd) setErrors((prev) => ({ ...prev, maxBudgetUsd: undefined }));
              }}
            />
            {errors.maxBudgetUsd && (
              <p css={errorMessageText}>
                <AlertTriangleIcon />
                {errors.maxBudgetUsd}
              </p>
            )}
            <p css={fieldHelpText}>Hard ceiling on USD cost.</p>
          </div>
        </div>

        {/* System Prompts */}
        <div css={formGroup}>
          <label css={fieldLabel} htmlFor="claude-agent-custom-system-prompt">
            Custom System Prompt (Replaces Default)
          </label>
          <textarea
            id="claude-agent-custom-system-prompt"
            css={textInput()}
            style={{ minHeight: "75px", height: "auto", padding: "10px 14px", resize: "vertical" }}
            placeholder="You are an enterprise code reviewer..."
            value={values.customSystemPrompt || ""}
            onChange={(e) => onChange({ customSystemPrompt: e.target.value })}
          />
          <p css={fieldHelpText}>
            Completely overrides the Claude Agent SDK default system prompt with your custom persona.
          </p>
        </div>

        <div css={formGroup}>
          <label css={fieldLabel} htmlFor="claude-agent-append-system-prompt">
            Append to System Prompt
          </label>
          <textarea
            id="claude-agent-append-system-prompt"
            css={textInput()}
            style={{ minHeight: "65px", height: "auto", padding: "10px 14px", resize: "vertical" }}
            placeholder="Always provide step-by-step diff summaries..."
            value={values.appendSystemPrompt || ""}
            onChange={(e) => onChange({ appendSystemPrompt: e.target.value })}
          />
          <p css={fieldHelpText}>
            Appends instructions to the agent without removing its standard tool guidance.
          </p>
        </div>

        {/* Advanced Configuration (JSON) */}
        <div css={formGroup}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <label css={fieldLabel} htmlFor="claude-agent-config-json">
              Advanced Configuration (JSON)
            </label>
            <button
              type="button"
              onClick={handleFormatJson}
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "6px",
                padding: "4px 10px",
                fontSize: "0.8rem",
                fontWeight: 650,
                background: "#f1f5f9",
                border: "1px solid #cbd5e1",
                borderRadius: "6px",
                cursor: "pointer",
              }}
              title="Format JSON with 2-space indentation"
            >
              <FormatAlignIcon />
              <span>Format</span>
            </button>
          </div>

          {/* Examples Collapsible */}
          <div style={{ border: "1px solid #e2e8f0", borderRadius: "8px", overflow: "hidden" }}>
            <button
              type="button"
              onClick={() => setExamplesExpanded(!examplesExpanded)}
              style={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "10px 14px",
                background: "#f8fafc",
                border: "none",
                cursor: "pointer",
                fontSize: "0.85rem",
                fontWeight: 650,
                color: "#475569",
              }}
            >
              <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <CodeBracketsIcon />
                <span>Examples</span>
              </span>
              <ChevronDownIcon
                style={{
                  transform: examplesExpanded ? "rotate(180deg)" : "rotate(0deg)",
                  transition: "transform 0.18s ease-in-out",
                }}
              />
            </button>

            {examplesExpanded && (
              <div style={{ padding: "14px", background: "#ffffff", borderTop: "1px solid #e2e8f0" }}>
                <ul style={{ listStyle: "none", padding: 0, margin: 0, display: "flex", flexDirection: "column", gap: "8px" }}>
                  {CLAUDE_AGENT_EXAMPLES_LIST.map((item, idx) => (
                    <li key={idx} style={{ fontSize: "0.84rem", color: "#475569" }}>
                      <pre style={{ background: "#f8fafc", padding: "6px 10px", borderRadius: "6px", border: "1px solid #e2e8f0", margin: "4px 0" }}>
                        {item.code}
                      </pre>
                      <span>{item.desc}</span>
                    </li>
                  ))}
                </ul>
                <button
                  type="button"
                  onClick={handleLoadExampleJson}
                  style={{
                    marginTop: "10px",
                    padding: "5px 12px",
                    fontSize: "0.82rem",
                    fontWeight: 650,
                    background: "#0f766e",
                    color: "#ffffff",
                    border: "none",
                    borderRadius: "6px",
                    cursor: "pointer",
                  }}
                >
                  Use This Example
                </button>
              </div>
            )}
          </div>

          <textarea
            id="claude-agent-config-json"
            style={{
              width: "100%",
              minHeight: "120px",
              padding: "12px 14px",
              fontFamily: "monospace",
              fontSize: "0.88rem",
              border: `1.5px solid ${jsonFormatError || errors.configJson ? "#ef4444" : "#cbd5e1"}`,
              borderRadius: "8px",
              outline: "none",
              resize: "vertical",
            }}
            placeholder="{}"
            value={values.configJson}
            onChange={(e) => {
              onChange({ configJson: e.target.value });
              if (jsonFormatError) setJsonFormatError(null);
              if (errors.configJson) setErrors((prev) => ({ ...prev, configJson: undefined }));
            }}
            spellCheck={false}
          />
          {jsonFormatError || errors.configJson ? (
            <p css={errorMessageText}>
              <AlertTriangleIcon />
              {jsonFormatError || errors.configJson}
            </p>
          ) : (
            <p css={fieldHelpText}>
              Optional JSON configuration passed to Claude Agent SDK (e.g. setting_sources, append_allowed_tools, disallowed_tools, append_system_pack).
            </p>
          )}
        </div>
      </div>

      {/* 3. Collapsible: Tools & Permissions */}
      <div css={collapsibleCard}>
        <button
          type="button"
          css={collapsibleTriggerButton(toolsExpanded)}
          onClick={() => setToolsExpanded(!toolsExpanded)}
          aria-expanded={toolsExpanded}
        >
          <div>
            <h3 css={collapsibleTitle}>Tools & Permissions</h3>
            <p css={collapsibleSubtitle}>
              Execution permissions, tool approval modes, side-effect controls, and sandbox paths.
            </p>
          </div>
          <ChevronDownIcon
            style={{
              transform: toolsExpanded ? "rotate(180deg)" : "rotate(0deg)",
              transition: "transform 0.18s ease-in-out",
              color: "#64748b",
            }}
          />
        </button>

        {toolsExpanded && (
          <div css={collapsibleBody}>
            <div css={gridTwoCols}>
              <div css={formGroup}>
                <label css={fieldLabel} htmlFor="claude-agent-permission-mode-select">
                  Permission Mode
                </label>
                <select
                  id="claude-agent-permission-mode-select"
                  css={selectControl}
                  value={values.permissionMode || "default"}
                  onChange={(e) => {
                    onChange({ permissionMode: e.target.value });
                    if (errors.permissionMode) setErrors((prev) => ({ ...prev, permissionMode: undefined }));
                  }}
                >
                  <option value="default">default (Ask confirmation for actions)</option>
                  <option value="plan">plan (Plan-only mode, no destructive actions)</option>
                  <option value="acceptEdits">acceptEdits (Automatically approve file modifications)</option>
                  <option value="dontAsk">dontAsk (Execute approved tools without confirmation)</option>
                  <option value="auto">auto (AI-managed tool safety approval)</option>
                  <option value="bypassPermissions">bypassPermissions (DANGEROUS: Bypass all permission checks)</option>
                </select>
                <p css={fieldHelpText}>Governs how Claude Agent SDK handles tool side-effects and approvals.</p>
              </div>

              {values.permissionMode === "bypassPermissions" && (
                <div
                  css={formGroup}
                  style={{
                    background: "#fef2f2",
                    padding: "12px 16px",
                    borderRadius: "8px",
                    border: "1.5px solid #fecaca",
                  }}
                >
                  <label css={checkboxRow}>
                    <input
                      type="checkbox"
                      checked={Boolean(values.allowDangerouslySkipPermissions)}
                      onChange={(e) => {
                        onChange({ allowDangerouslySkipPermissions: e.target.checked });
                        if (errors.permissionMode) setErrors((prev) => ({ ...prev, permissionMode: undefined }));
                      }}
                    />
                    <div>
                      <span css={checkboxLabel} style={{ color: "#b91c1c" }}>
                        Confirm Dangerously Skip Permissions
                      </span>
                      <p css={fieldHelpText} style={{ color: "#991b1b", marginTop: "2px" }}>
                        Required safety flag when using <code>bypassPermissions</code> mode.
                      </p>
                    </div>
                  </label>
                  {errors.permissionMode && (
                    <p css={errorMessageText}>
                      <AlertTriangleIcon />
                      {errors.permissionMode}
                    </p>
                  )}
                </div>
              )}
            </div>

            <div css={gridTwoCols}>
              <div css={formGroup}>
                <label css={fieldLabel} htmlFor="claude-agent-append-allowed-tools">
                  Additional Allowed Tools
                </label>
                <input
                  id="claude-agent-append-allowed-tools"
                  type="text"
                  css={textInput()}
                  placeholder="e.g. Write, Edit, MultiEdit"
                  value={(values.appendAllowedTools || []).join(", ")}
                  onChange={(e) =>
                    onChange({
                      appendAllowedTools: e.target.value
                        .split(",")
                        .map((s) => s.trim())
                        .filter(Boolean),
                    })
                  }
                />
                <p css={fieldHelpText}>Comma-separated tools to auto-approve.</p>
              </div>

              <div css={formGroup}>
                <label css={fieldLabel} htmlFor="claude-agent-disallowed-tools">
                  Explicitly Disallowed Tools
                </label>
                <input
                  id="claude-agent-disallowed-tools"
                  type="text"
                  css={textInput()}
                  placeholder="e.g. Bash, Run"
                  value={(values.disallowedTools || []).join(", ")}
                  onChange={(e) =>
                    onChange({
                      disallowedTools: e.target.value
                        .split(",")
                        .map((s) => s.trim())
                        .filter(Boolean),
                    })
                  }
                />
                <p css={fieldHelpText}>Tools to explicitly block.</p>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* 4. Collapsible: Test Generation */}
      <div css={collapsibleCard}>
        <button
          type="button"
          css={collapsibleTriggerButton(testGenExpanded)}
          onClick={() => setTestGenExpanded(!testGenExpanded)}
          aria-expanded={testGenExpanded}
        >
          <div>
            <h3 css={collapsibleTitle}>Test Generation</h3>
            <p css={collapsibleSubtitle}>
              Configure how red team test cases are generated for this target
            </p>
          </div>
          <ChevronDownIcon
            style={{
              transform: testGenExpanded ? "rotate(180deg)" : "rotate(0deg)",
              transition: "transform 0.18s ease-in-out",
              color: "#64748b",
            }}
          />
        </button>

        {testGenExpanded && (
          <div css={collapsibleBody}>
            <div css={formGroup}>
              <label css={fieldLabel} htmlFor="test-gen-instructions-input">
                Instructions
              </label>
              <textarea
                id="test-gen-instructions-input"
                css={textInput()}
                style={{ minHeight: "80px", height: "auto", padding: "10px 14px", resize: "vertical" }}
                placeholder="Generate the attack as a news article"
                value={values.testGenerationInstructions}
                onChange={(e) => onChange({ testGenerationInstructions: e.target.value })}
              />
              <p css={fieldHelpText}>
                Additional guidance for generating red team attacks.
              </p>
            </div>
          </div>
        )}
      </div>

      {/* 5. Collapsible: Delay */}
      <div css={collapsibleCard}>
        <button
          type="button"
          css={collapsibleTriggerButton(delayExpanded)}
          onClick={() => setDelayExpanded(!delayExpanded)}
          aria-expanded={delayExpanded}
        >
          <div>
            <h3 css={collapsibleTitle}>Delay</h3>
            <p css={collapsibleSubtitle}>
              Configure the delay between requests
            </p>
          </div>
          <ChevronDownIcon
            style={{
              transform: delayExpanded ? "rotate(180deg)" : "rotate(0deg)",
              transition: "transform 0.18s ease-in-out",
              color: "#64748b",
            }}
          />
        </button>

        {delayExpanded && (
          <div css={collapsibleBody}>
            <div css={formGroup}>
              <label css={fieldLabel} htmlFor="claude-delay-ms-input">
                Delay (ms)
              </label>
              <input
                id="claude-delay-ms-input"
                type="number"
                min="0"
                css={textInput()}
                placeholder="0"
                value={values.delayMs}
                onChange={(e) => onChange({ delayMs: e.target.value ? Number(e.target.value) : 0 })}
              />
              <p css={fieldHelpText}>
                Millisecond pause between consecutive red team probes.
              </p>
            </div>
          </div>
        )}
      </div>

      {/* 6. Collapsible: Extension Hook */}
      <div css={collapsibleCard}>
        <button
          type="button"
          css={collapsibleTriggerButton(extHookExpanded)}
          onClick={() => setExtHookExpanded(!extHookExpanded)}
          aria-expanded={extHookExpanded}
        >
          <div>
            <h3 css={collapsibleTitle}>Extension Hook</h3>
            <p css={collapsibleSubtitle}>
              Run custom code at specific points in the evaluation lifecycle
            </p>
          </div>
          <ChevronDownIcon
            style={{
              transform: extHookExpanded ? "rotate(180deg)" : "rotate(0deg)",
              transition: "transform 0.18s ease-in-out",
              color: "#64748b",
            }}
          />
        </button>

        {extHookExpanded && (
          <div css={collapsibleBody}>
            <div css={formGroup}>
              <label css={fieldLabel} htmlFor="claude-ext-hook-input">
                Extension Hook Path
              </label>
              <input
                id="claude-ext-hook-input"
                type="text"
                css={textInput()}
                placeholder="file://path/to/hook.js"
                value={values.extensionHook}
                onChange={(e) => onChange({ extensionHook: e.target.value })}
              />
              <p css={fieldHelpText}>
                Path to a custom extension hook script.
              </p>
            </div>
          </div>
        )}
      </div>

      {/* 7. Section: Prompts */}
      <div css={sectionCard}>
        <div>
          <h3 css={collapsibleTitle}>Prompts</h3>
          <p css={collapsibleSubtitle}>
            Prompt template used for probe execution. Use <code>{"{{ prompt }}"}</code> or <code>{"{{prompt}}"}</code> as the dynamic attack insertion point.
          </p>
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
          {values.prompts.map((p, idx) => (
            <div key={idx} css={promptItemRow}>
              <input
                id={`claude-prompt-input-${idx}`}
                type="text"
                css={textInput(!!errors.prompts)}
                placeholder="{{prompt}}"
                value={p}
                onChange={(e) => handlePromptChange(idx, e.target.value)}
              />
              <button
                type="button"
                css={trashButton}
                onClick={() => handleRemovePrompt(idx)}
                disabled={values.prompts.length <= 1}
                title={`Remove prompt ${idx + 1}`}
                aria-label={`Remove prompt ${idx + 1}`}
              >
                <TrashIcon />
              </button>
            </div>
          ))}

          {errors.prompts && (
            <p css={errorMessageText}>
              <AlertTriangleIcon />
              {errors.prompts}
            </p>
          )}

          <button type="button" css={addPromptButton} onClick={handleAddPrompt}>
            <PlusIcon />
            <span>Add Prompt</span>
          </button>
        </div>
      </div>

      {/* 8. Bottom Navigation Bar */}
      {!hideBottomBar && (
        <div css={bottomNavRow}>
          <Button variant="default" onClick={onBack}>
            &lt; Back
          </Button>
          <Button variant="primary" onClick={handleNextClick}>
            Next &gt;
          </Button>
        </div>
      )}
    </div>
  );
}
